export const CATALOGUE_URL =
  process.env.REACT_APP_CATALOGUE_URL ||
  "/catalogue/al-waab-plastics-cpvc-catalogue-2019.pdf";

export const CONTACT_EMAIL =
  process.env.REACT_APP_CONTACT_EMAIL || "info@flowwhiteuae.com";
